import{ALL_BLOCK_TYPES as e}from"../../components/template/types/defaults.js";const t=({exclude:t})=>e.filter(e=>!t.includes(e));export{t as excludeBlockTypes};
